/**
 * Created by Victor Rojo on 5/10/18.
 */
import { Injectable, Optional, OnDestroy }     from '@angular/core';
import { Router }                   from '@angular/router';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Unsubscribable as AnonymousSubscription ,  Subject }             from "rxjs";

import {AuthService} from "../shared/auth/auth.service";
import {WidgetStatus} from "./widget/Widget";
import {NotificationMessage} from "./notificationMessage/NotificationMessage";
import {Tank, TankDelivery} from "./ipetrol/Tank";
import {Pump} from "./ipetrol/Pump";
import {PricePole} from "./ipetrol/PricePole";
import {SSEElement} from "./element/Element";
import {StatusNotificationMessage} from "./statusNotification/StatusNotificationMessage";

@Injectable()
export class IPlaceDataChangeService implements OnDestroy {

  private basePath = "api/v1/";
  private interval: AnonymousSubscription;
  private widgetStatusSource = new Subject<Object>();
  private statusNotificationSource = new Subject<Object>();
  private notificationSource = new Subject<Object>();
  private tankSource = new Subject<Object>();
  private pumpSource = new Subject<Object>();
  private pricePoleSource = new Subject<Object>();
  private tankDeliverySource = new Subject<Object>();
  private elementSource = new Subject<Object>();
  private eventSource: any;
  private SSE: any = window['EventSource'];
  widgetStatusChange$ = this.widgetStatusSource.asObservable();
  statusNotificationChange$ = this.statusNotificationSource.asObservable();
  notificationChange$ = this.notificationSource.asObservable();
  tankChange$ = this.tankSource.asObservable();
  pumpChange$ = this.pumpSource.asObservable();
  pricePoleChange$ = this.pricePoleSource.asObservable();
  tankDeliveryChange$ = this.tankDeliverySource.asObservable();
  elementChange$ = this.elementSource.asObservable();

  constructor(private http:HttpClient,
              private router: Router,
              private authService: AuthService) {

  }

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  startSSE(iPlaceId:string){
    let url = iPlaceId ? this.basePath + "iplace/" + iPlaceId + "/data_change/stream" : this.basePath + "data_change/stream";
    this.stopSSE();
    this.eventSource = new this.SSE(url);
    this.eventSource.addEventListener('widgetStatus', (event:any) => {
      this.widgetStatusSource.next(JSON.parse(event.data) as WidgetStatus);
    });
    this.eventSource.addEventListener('statusNotification', (event:any) => {
      this.statusNotificationSource.next(JSON.parse(event.data) as StatusNotificationMessage);
    });
    this.eventSource.addEventListener('notification', (event:any) => {
      this.notificationSource.next(JSON.parse(event.data) as NotificationMessage);
    });
    this.eventSource.addEventListener('tank', (event:any) => {
      this.tankSource.next(JSON.parse(event.data) as Tank);
    });
    this.eventSource.addEventListener('pump', (event:any) => {
      this.pumpSource.next(JSON.parse(event.data) as Pump);
    });
    this.eventSource.addEventListener('pricepole', (event:any) => {
      this.pricePoleSource.next(JSON.parse(event.data) as PricePole);
    });
    this.eventSource.addEventListener('tankDeliveryLog', (event:any) => {
      this.tankDeliverySource.next(JSON.parse(event.data) as TankDelivery);
    });
    this.eventSource.addEventListener('element', (event:any) => {
      this.elementSource.next(JSON.parse(event.data) as SSEElement);
    });

  }

  stopSSE(){
    if ( this.eventSource ) {
      this.eventSource.close();
    }
  }

  public ngOnDestroy(): void {
    this.stopSSE();
  }
}
